import React, { Component } from "react";
import { connect } from "react-redux";
import ThumbnailDefault from "./modules/thumbnail/ThumbnailDefault";
import InformationDefault from "./modules/information/InformationDefault";
import ComboProductInformationDefault from "./modules/information/ComboProductInformationDefault";
import SingleProductInformationDefault from "./modules/information/SingleProductInformationDefault";
import SchemeProductDetails from "./modules/information/SchemeProductDetails";
import { PRODUCT_TYPE } from "./../../../utilities/constants";
import DefaultDescription from "../detail/modules/description/DefaultDescription";
import { Tabs } from "antd";

const { TabPane } = Tabs;
  

class ProductDetailFullwidth extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedKycData: "0"
    };
  }

  render() {
      const { productData, isComboProduct, productType, allProductData, allMainProducts, allFOCProducts, schemeMainProductData, schemeFOCProductData, comboSchemeId } = this.props;

    if (productData !== null) {
      return (
        
        <div className="ps-product--detail ps-product--fullwidth">
          {/* <TopHeader 
            product={productData}
          /> */}
          <div className="ps-product__header">
            {isComboProduct ? (
              <React.Fragment>
                <ThumbnailDefault
                  product={productData}
                  mediaBaseURL={this.props.mediaBaseURL}
                />
                <ComboProductInformationDefault
                    productData={productData}
                    allMainProducts={allMainProducts}
                    allFOCProducts={allFOCProducts}
                  comboProductId={this.props.comboProductId}
                  mediaBaseURL={this.props.mediaBaseURL}
                  selectedProductRation={this.props.selectedProductRation}
                  firstProductRation={this.props.firstProductRation}
                  isFirstRation={this.props.isFirstRation}
                  selectedQuantity={this.props.selectedQuantity}
                  handleIncreaseItemQty={this.handleIncreaseItemQty}
                  handleDecreseItemQty={this.handleDecreseItemQty}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <ThumbnailDefault
                  product={productData}
                  mediaBaseURL={this.props.mediaBaseURL}
                />
                {productType === PRODUCT_TYPE.SINGEL ? (
                  <SingleProductInformationDefault
                    productData={productData}
                    mediaBaseURL={this.props.mediaBaseURL}
                  />
                ) : ( productType === PRODUCT_TYPE.COMBOSCHEME ? (<Tabs className="col-lg-7"
                                      defaultActiveKey={"0"}
                                      onChange={(e) => this.handleKYCTabChange(e)}
                                      activeKey={this.state.selectedKycData}
                                    >
                                    <TabPane tab="Main Product" key={"0"}>                                     
                                      <SchemeProductDetails
                                              isMainProductScheme={true}
                                              productData={schemeMainProductData}
                                              allMainProducts={allMainProducts}
                                              allFOCProducts={allFOCProducts}
                                              schemeMainProductData={schemeMainProductData}
                                        mediaBaseURL={this.props.mediaBaseURL}
                                        onAttributeSelectionChange={this.props.onAttributeSelectionChange}
                                        getSelectedAttributeList={this.props.getSelectedAttributeList}
                                        comboSchemeId={comboSchemeId}
                                      />
                                  </TabPane>
                                  <TabPane tab="Scheme Product" key={"1"}>                                     
                                      <SchemeProductDetails
                                        isMainProductScheme={false}
                                              productData={schemeFOCProductData}
                                              allMainProducts={allMainProducts}
                                              allFOCProducts={allFOCProducts}
                                              schemeFOCProductData={schemeFOCProductData}
                                        mediaBaseURL={this.props.mediaBaseURL}
                                        onAttributeSelectionChange={this.props.onAttributeSelectionChange}
                                        getSelectedAttributeList={this.props.getSelectedAttributeList}
                                        comboSchemeId={comboSchemeId}
                                      />
                                  </TabPane>
                </Tabs> ) : (
                  <InformationDefault
                    productData={productData}
                    allProductData={allProductData}
                    mediaBaseURL={this.props.mediaBaseURL}
                    onAttributeSelectionChange={this.props.onAttributeSelectionChange}
                    getSelectedAttributeList={this.props.getSelectedAttributeList}
                  />
                ))}
               
              </React.Fragment>
            )}
             
          </div>
          
          <DefaultDescription product={productData}/>
        </div>
      );
    } else {
      return <p>No Data</p>;
    }
  }

  handleIncreaseItemQty = (row, productQty, comboProductId) => {
    this.props.handleIncreaseItemQty(
      row,
      productQty,
      this.props.comboProductId
    );
  };

  handleDecreseItemQty = (row, productQty, comboProductId) => {
    this.props.handleDecreseItemQty(row, productQty, this.props.comboProductId);
  };

  handleKYCTabChange = (key) => {
    this.setState({
      selectedKycData: key
    });
  };
}

const mapStateToProps = (state) => {
  return state.product;
};

export default connect(mapStateToProps)(ProductDetailFullwidth);

